import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Linkedin, Facebook, ArrowUpRight } from "lucide-react";
import { LOGO_DARK_URL, COMPANY } from "../lib/brand";

export default function Footer() {
  return (
    <footer className="bg-carbon-950 text-slate-300 mt-20 md:mt-24" data-testid="site-footer">
      {/* Top accent bar */}
      <div className="h-1 bg-gradient-to-r from-brand-500 via-amber-500 to-brand-500" />

      <div className="max-w-[1600px] 2xl:max-w-[1760px] mx-auto px-5 md:px-8 py-14 md:py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
        <div>
          <div className="mb-5">
            <img
              src={LOGO_DARK_URL}
              alt="Universal Electricals & Electronics"
              className="h-20 md:h-24 w-auto object-contain logo-glow"
              data-testid="footer-logo"
            />
          </div>
          <p className="text-sm leading-relaxed text-slate-400 mb-4">
            Founded in 2016 in KG Halli, Bangalore — an Electronics R&amp;D and Mining
            Safety Equipment Trading and Service company offering AFDSS, Anti-Tilt,
            Rear-View Camera, Driver Fatigue, VFD &amp; Proximity solutions.
          </p>
          <div className="flex flex-wrap items-center gap-2 text-[10px] tracking-[0.22em] text-amber-400 font-bold font-mono">
            <span className="border border-amber-500 px-2 py-1">MINING SAFETY</span>
            <span className="border border-amber-500 px-2 py-1">E&amp;E SOLUTIONS</span>
          </div>
        </div>

        <div>
          <div className="overline mb-4 text-slate-400">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-amber-400 inline-flex items-center gap-1">Home <ArrowUpRight className="w-3 h-3 opacity-50" /></Link></li>
            <li><Link to="/about" className="hover:text-amber-400 inline-flex items-center gap-1">About Us <ArrowUpRight className="w-3 h-3 opacity-50" /></Link></li>
            <li><Link to="/products" className="hover:text-amber-400 inline-flex items-center gap-1">Products <ArrowUpRight className="w-3 h-3 opacity-50" /></Link></li>
            <li><Link to="/news" className="hover:text-amber-400 inline-flex items-center gap-1">News &amp; Updates <ArrowUpRight className="w-3 h-3 opacity-50" /></Link></li>
            <li><Link to="/contact" className="hover:text-amber-400 inline-flex items-center gap-1">Contact <ArrowUpRight className="w-3 h-3 opacity-50" /></Link></li>
            <li><Link to="/login" className="hover:text-amber-400 inline-flex items-center gap-1">Staff Login <ArrowUpRight className="w-3 h-3 opacity-50" /></Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4 text-slate-400">Capabilities</div>
          <ul className="space-y-2 text-sm">
            <li>AFDSS Fire Suppression</li>
            <li>Driver Fatigue &amp; Alert Systems</li>
            <li>Anti-Tilt &amp; Body Lifting Alarms</li>
            <li>Rear-View Camera Systems</li>
            <li>VFD · Work Lamps · Beacons</li>
            <li>LIDAR / Ultrasonic Proximity</li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4 text-slate-400">Reach Us</div>
          <ul className="space-y-3 text-sm">
            {COMPANY.units.map((u, i) => (
              <li key={i} className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-amber-500 shrink-0" />
                <div>
                  <div className="text-[10px] uppercase tracking-[0.22em] text-amber-400 font-bold font-mono mb-0.5">
                    {u.label}
                  </div>
                  {u.lines.map((ln, j) => (
                    <div key={j} className="leading-snug">{ln}</div>
                  ))}
                </div>
              </li>
            ))}
            <li className="flex gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-amber-500 shrink-0" />
              <div className="flex flex-col gap-1">
                <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-amber-400">{COMPANY.phone}</a>
                <a href={`tel:${COMPANY.phone2Raw}`} className="hover:text-amber-400">{COMPANY.phone2}</a>
              </div>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-amber-500 shrink-0" />
              <div className="flex flex-col gap-1">
                <a href={`mailto:${COMPANY.email1}`} className="hover:text-amber-400">{COMPANY.email1}</a>
                {COMPANY.email2 && COMPANY.email2 !== COMPANY.email1 && (
                  <a href={`mailto:${COMPANY.email2}`} className="hover:text-amber-400">{COMPANY.email2}</a>
                )}
              </div>
            </li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a href="#" aria-label="LinkedIn" className="w-9 h-9 grid place-items-center border border-slate-700 hover:border-amber-500 hover:text-amber-400 transition-colors">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 grid place-items-center border border-slate-700 hover:border-amber-500 hover:text-amber-400 transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-[1600px] 2xl:max-w-[1760px] mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row justify-between text-xs text-slate-500 gap-2">
          <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
          <span className="font-mono">GSTIN: {COMPANY.gst}</span>
        </div>
      </div>
    </footer>
  );
}
